export default class SelectCheckbox{
    
    constructor(element) {
        this._wrapper = element;
        this._items = this._wrapper.querySelectorAll('.js-select-checkbox-item');
        this.facetKey = this._wrapper.getAttribute('data-facet');
        
        this.bindEvents();
    }
    
    bindEvents(){
        document.addEventListener('facetwp-loaded', this.updateUI.bind(this));
        app.nodesEventListener('click', this._items, this.onClickItem.bind(this));
    }
    
    updateUI(){
        let activeFacets = FWP.facets[this.facetKey];
        if(!activeFacets.length){
            app.nodesEach(this._items, (el,n) => {
               el.checked = true;
            });
        }
        else{
            app.nodesEach(this._items, (el,n) => {
                if(activeFacets.includes(el.value)){
                    el.checked = true;
                }
            });
        }
    }
    
    onClickItem(el,n,e){
        FWP.facets[this.facetKey] = [];
        app.nodesEach(this._items, (el,n) => {
            if(el.checked){
                FWP.facets[this.facetKey].push(el.value);
            }
        });
        FWP.fetchData();
        FWP.setHash();
    }
}